import { Range, Transaction } from 'types';
import { createTransaction } from 'modules/transactions/utils/createTransaction';
import transactionTypes from 'constants/transactionTypes';

type GetTransactionsProps = {
  validatedRanges: Range[];
  partnerId: string;
  holdingClassId: string;
  sharePrice: number;
};

export const getTransactions = ({
  validatedRanges,
  partnerId,
  holdingClassId,
  sharePrice,
}: GetTransactionsProps): Transaction[] => {
  const transactions: Transaction[] = [];

  validatedRanges.forEach((range: Range) => {
    const newTransaction = createTransaction({
      range: {
        from: range.from,
        to: range.to,
        partner: partnerId,
        shareClass: holdingClassId,
        sharePrice,
      },
      transactionType: transactionTypes.CAPITAL_DECREASE,
    }) as Transaction;
    transactions.push(newTransaction);
  });

  return transactions;
};
